import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'de', label: 'DE' },
  { code: 'en', label: 'EN' },
];

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || 'de';

  return (
    <div
      className="inline-flex rounded-md border border-primary-300 dark:border-accent-500/40 overflow-hidden text-xs"
      role="group"
      aria-label={t('nav.language')}
    >
      {LANGS.map((lang) => (
        <button
          key={lang.code}
          onClick={() => i18n.changeLanguage(lang.code)}
          className={`px-2 py-1 ${
            current === lang.code
              ? 'bg-primary-500 dark:bg-accent-500 text-white'
              : 'miko-text-muted hover:bg-primary-50 dark:hover:bg-yoru-300/40'
          }`}
          title={lang.label}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
